module.exports = __webpack_public_path__ + "img/product_icon_4.82745286.png";